const NOTIFICATIONS_VAPID_PUBLIC_KEY =
    process.env.REACT_APP_NOTIFICATIONS_VAPID_PUBLIC_KEY;

export const setupNotifications = async (connection) => {
    return new Promise((resolve, reject) => {
        if (!navigator || !("serviceWorker" in navigator)) {
            reject("دستگاه شما از این قابلیت پشتیبانی نمیکند.");
        } else {
            navigator.serviceWorker
                .register("/service-worker.js")
                .then((registration) => {
                    const askNotificationPermission = () => {
                        if (!Notification) {
                            reject("دستگاه شما از این قابلیت پشتیبانی نمیکند.");
                            return;
                        }
                        Notification.requestPermission()
                            .then((permission) => {
                                if (permission === "granted") {
                                    console.log(NOTIFICATIONS_VAPID_PUBLIC_KEY);
                                    // self.registration = registration;
                                    navigator.serviceWorker.ready
                                        .then(() => {
                                            registration.pushManager
                                                .subscribe({
                                                    userVisibleOnly: true,
                                                    applicationServerKey:
                                                        NOTIFICATIONS_VAPID_PUBLIC_KEY,
                                                })
                                                .then((subscription) => {
                                                    subscription = JSON.parse(
                                                        JSON.stringify(
                                                            subscription
                                                        )
                                                    );
                                                    connection
                                                        .subscribe_notifications(
                                                            subscription
                                                        )
                                                        .then(({ data }) => {
                                                            resolve(data);
                                                        })
                                                        .catch((err) => {
                                                            reject(
                                                                "خطای شبکه : " +
                                                                    err.response
                                                                        ?.data
                                                            );
                                                        });
                                                })
                                                .catch((err) => {
                                                    reject(
                                                        "خطا در ایجاد اشتراک 2: " +
                                                            err
                                                    );
                                                });
                                        })
                                        .catch((err) => {
                                            reject(
                                                "خطا در ایجاد اشتراک 1: " + err
                                            );
                                        });
                                } else {
                                    reject(
                                        "در خواست اجازه نوتیفیکیشن توسط شما رد شد."
                                    );
                                }
                            })
                            .catch((err) => {
                                reject(
                                    "خطا در درخواست اجازه نوتیفیکیشن : تنظیمات مرورگر را چک کنید."
                                );
                            });
                    };
                    askNotificationPermission();
                })
                .catch((err) => {
                    reject("خطا در ایجاد خدمات نوتیفیکیشن : " + err);
                });
        }
    });
};
